module.exports = __webpack_public_path__ + "static/media/info.20ae1a2e.png";